import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

export interface ItensTesteBandeja {
  nome_equipamento: string
  nome_propriedade: string
  nome_usuario:string
  cod: number
  cod_usuario: number
  cod_conta: number
  cod_cliente: number
  cod_propriedade: number
  cod_equipamento: number
  data: string
  tipomonitor: string
  obs: string
  produto: string
  tipo: string
  status: number
  marcha: string
  hash_sinc: null
  teste_rapido: false
  melhor_regulagem: false
  medicao: [
    {
      cod: number
      cod_teste: number
      data: string
      teste_rapido: 0
      corrente: string
      nivelamento: string
      pqueda: string
      desgastepalheta: string
      condicoesdiscos: string
      tipoangulacao: string
      posicaopalhetas: string
      p1: number
      p2: number
      p3: number
      p4: number
      p5: number
      p6: number
      tipocomporta: string
      comporta: number
      rpmdisco: number
      vento: string
      obs: null
      fatorcalibra: string
      precisaocalibra: string
      bitola: string
      chapa: string
      largurachapa: string
      caixa: string
      recambio: string
      motriz: number
      movida: number
      larguratrab: string
      taxafixa: string
      qtdepares: string
      tamanhopalhetas: string
      menores: number
      maiores: number
      tipoesteira: string
      condicoesesteira: string
      alinhamentoesteira: string
      veltrab: string
      rpm: number
      largura_bandeja: string
      comprimento_bandeja: string
      espacamento_bandeja: string
      tara: string
      sinc: number
      status: number
      peso1: string
      peso2: string
      peso3: string
      peso4: string
      peso5: string
      peso6: string
      peso7: string
      peso8: string
      peso9: string
      peso10: string
      peso11: string
      peso12: string
      peso13: string
      peso14: string
      peso15: string
      peso16: string
      peso17: string
      peso18: string
      peso19: string
      peso20: string
      peso21: string
      peso22: string
      peso23: string
      peso24: string
      peso25: string
      peso26: string
      peso27: string
      peso28: string
      peso29: string
      peso30: string
      peso31: string
      peso32: string
      peso33: string
      peso34: string
      peso35: string
      peso36: string
      peso37: string
      peso38: string
      peso39: string
      peso40: string
      peso41: string
      peso42: string
      peso43: string
      peso44: string
      peso45: string
      peso46: string
      peso47: string
      peso48: string
      peso49: string
      peso50: string
      peso51: string
      peso52: string
      peso53: string
      peso54: string
      peso55: string
      peso56: string
      peso57: string
      peso58: string
      peso59: string
      peso60: string
      peso61: string
      peso62: string
      resp_calibra: string
    }
  ]
}

export interface TestesBandeja {
  itens: ItensTesteBandeja[]
  total?: number | null
  mensagem?: string | null
}

export const useGetTesteBandeja = (pagination = 15, page = 1, nome?:string) => {
  const queryKey: any = [`/regulagem/teste`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    TestesBandeja,
    Error
  >(
    queryKey,
    async () => {
      return api
        .get(
          `/regulagem/teste?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&pagination=${pagination}&page=${page}&nome=${nome}&order=-data`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de teste de bandeja!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_teste_bandeja: data,
    carregando_teste_bandeja: isFetching,
    refetch_data_teste_bandeja: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetTesteBandejaEditar = (cod) => {
  const queryKey: any = [`/regulagem/medicao_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery(
    queryKey,
    async () => {
      return api
        .get(
          `/regulagem/medicao?codConta=${localConfig()?.conta}&codTeste=${cod}&codCliente=${
            localConfig()?.codCliente
          }&pagination=-1`
        )
        .then((response): any => {
          return response.data.itens
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de teste de bandeja!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_teste_bandeja_editar: data ?? [],
    carregando_teste_bandeja_editar: isFetching,
    refetch_data_teste_bandeja_editar: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetTesteBandejaCalculo = (codTeste, cod) => {
  const queryKey: any = [`/regulagem/medicao_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery(
    queryKey,
    async () => {
      return api
        .get(
          `/regulagem/medicao?codConta=${localConfig()?.conta}&codTeste=${codTeste}&cod=${cod}&codCliente=${
            localConfig()?.codCliente
          }&embed=calculo&pagination=-1`
        )
        .then((response): any => {
          return response.data.itens
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de teste de bandeja!')
        })
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_teste_bandeja_calculo: data ?? [],
    carregando_teste_bandeja_calculo: isFetching,
    refetch_data_teste_bandeja_calculo: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}
